module.exports = __webpack_public_path__ + "2e6e07e29d277b139b8dfbeec05fa075.png";